import React, { PropsWithChildren, forwardRef } from 'react';
import ReactDOM from 'react-dom';
import { classNames } from '../util/helpers';
import './style.scss';

export const PopoverPositions = ['bottom-left', 'bottom-center', 'bottom-right', 'top-left', 'top-center', 'top-right', 'left-top', 'left-center', 'left-bottom',
    'right-top', 'right-bottom', 'right-center'] as const;
export const Spacings = ["none", "compact", "default"] as const;

export type PopoverSpacingType = typeof Spacings[number];
export type PopoverPositionType = typeof PopoverPositions[number];

export type PopoverProps = {
    floating?: boolean;
    className?: string;
} & PropsWithChildren;

const PopoverModal = forwardRef<HTMLDivElement, PropsWithChildren>(({ children, ...props }, ref) => {
    return <div data-testid="popover" {...props} ref={ref}>
        {children}
    </div>;
});

PopoverModal.displayName = 'PopoverModal';

const Popover = forwardRef<HTMLDivElement, PopoverProps>(function (props: PopoverProps, ref) {

    const { floating = false, children, className, ...rest } = props;

    const popoverClassName = classNames(!className?.includes('ted-ui-popover') && 'ted-ui-popover', className);

    const popoverProps: React.HTMLProps<HTMLDivElement> = {
        className: popoverClassName,
        children,
        ...rest
    }

    if (floating) return ReactDOM.createPortal(<PopoverModal {...popoverProps} ref={ref} />, document.body);

    return <PopoverModal {...popoverProps} ref={ref} />;

});

Popover.displayName = 'Popover';

export default Popover;
